
export const MemberIdKindType = {
    code: 'バーコード番号をお持ちの方',
    old_member_id: '7桁の会員番号をお持ちの方'
} as const
export type MemberIdKindType = keyof typeof MemberIdKindType
// export type MemberIdKindType = 'code' | 'old_member_id'
